import { request } from './core.api';

export type InsuranceType = 'Brandverzekering' | 'Aansprakelijkheid' | 'Huurwaarborgverzekering' | 'Rechtsbijstand';

export interface InsuranceDto {
  id: string;
  propertyId: string;
  propertyAddress: string;
  type: InsuranceType;
  companyName: string;
  policyNumber: string;
  expiryDate: string;
  notes?: string;
  policyDocumentId?: string;
  createdAt: string;
  updatedAt: string;
}

export interface CreateInsuranceRequest {
  propertyId: string;
  type: InsuranceType;
  companyName: string;
  policyNumber: string;
  expiryDate: string;
  notes?: string;
}

export interface UpdateInsuranceRequest {
  type: InsuranceType;
  companyName: string;
  policyNumber: string;
  expiryDate: string;
  notes?: string;
}

export const insurancesApi = {
  getByProperty: (propertyId: string) => request<InsuranceDto[]>(`/properties/${propertyId}/insurances`),
  getById: (id: string) => request<InsuranceDto>(`/insurances/${id}`),
  create: (data: CreateInsuranceRequest) => request<InsuranceDto>('/insurances', { method: 'POST', body: JSON.stringify(data) }),
  update: (id: string, data: UpdateInsuranceRequest) => request<InsuranceDto>(`/insurances/${id}`, { method: 'PUT', body: JSON.stringify(data) }),
  delete: (id: string) => request<void>(`/insurances/${id}`, { method: 'DELETE' }),
};
